<app-voucher-titulo></app-voucher-titulo>
<app-spinner *ngIf="bancos === undefined || vouchersParaResgate !== undefined"></app-spinner>
<div *ngIf="bancos !== undefined && vouchersParaResgate === undefined" class="col-xs-12 col-md-8 col-md-offset-2">
  <div class="panel panel-default">
    <div class="panel-heading">
      Dados do Favorecido
    </div>
    <div class="panel-body">
      <form (submit)="resgatar()" ngNativeValidate>
        <div class="form-group col-xs-12">
          <label for="documento">Documento (CPF ou CNPJ)</label>
          <div class="input-group">
            <div class="input-group-btn">
              <button type="button" class="btn btn-sm"
                [ngClass]="{'app-btn-best': documentoTipo === enumTipoDeDocumento.CPF}"
                (click)="documentoTipo = enumTipoDeDocumento.CPF">
                <i [ngClass]="{'fa fa-check' : documentoTipo === enumTipoDeDocumento.CPF}"></i> CPF
              </button>
              <button type="button" class="btn btn-sm "
                [ngClass]="{'app-btn-best': documentoTipo === enumTipoDeDocumento.CNPJ}"
                (click)="documentoTipo = enumTipoDeDocumento.CNPJ">
                <i [ngClass]="{'fa fa-check': documentoTipo === enumTipoDeDocumento.CNPJ}"></i> CNPJ
              </button>
            </div>
            <input type="text" id="documento" class="form-control input-sm" [ngModel]="conta?.getTitularDocumento()"
              (ngModelChange)="conta?.setTitularDocumento($event)" name="documento"
              *ngIf="documentoTipo === enumTipoDeDocumento.CPF" UiCpf required>
            <input type="text" id="documento" class="form-control input-sm" [ngModel]="conta?.getTitularDocumento()"
              (ngModelChange)="conta?.setTitularDocumento($event)" name="titularDocumento"
              *ngIf="documentoTipo === enumTipoDeDocumento.CNPJ" UiCnpj required>
          </div>
        </div>
        <div class="form-group col-xs-12">
          <label for="nome">Nome completo ou Razão social</label>
          <input type="text" class="form-control" id="nome" [ngModel]="conta?.getTitularNome()"
            (ngModelChange)="conta?.setTitularNome($event)" name="titularNome" maxlength="256" required>
        </div>
        <div class="form-group col-xs-12">
          <label for="banco">Banco</label>
          <select id="banco" class="form-control" [ngModel]="banco?.getId()" (ngModelChange)="banco?.setId($event)"
            name="banco" required>
            <option value=""></option>
            <option *ngFor="let banco of bancos" value="{{ banco?.getId() }}">
              {{ banco?.getCodigo() + ' - ' + banco?.getNome() }}
            </option>
          </select>
        </div>
        <div class="form-group col-xs-12 col-md-8">
          <label for="agencia">Agência</label>
          <input type="text" class="form-control" id="agencia" [ngModel]="conta?.getAgencia()"
            (ngModelChange)="conta?.setAgencia($event)" name="agencia" UiNumeros maxlength="5" required>
        </div>
        <div class="form-group col-xs-12 col-md-4">
          <label for="agenciaDigito">Dígito da agência</label>
          <input type="text" class="form-control" id="agenciaDigito" [ngModel]="conta?.getAgenciaDigito()"
            (ngModelChange)="conta?.setAgenciaDigito($event)" name="agenciaDigito" maxlength="1" UiNumeros>
        </div>
        <div class="form-group col-xs-12 col-md-8">
          <label for="conta">Conta</label>
          <input type="text" class="form-control" id="conta" [ngModel]="conta?.getNumero()"
            (ngModelChange)="conta?.setNumero($event)" name="conta.numero" UiNumeros max="13" required>
        </div>
        <div class="form-group col-xs-12 col-md-4">
          <label for="contaDigito">Dígito da conta</label>
          <input type="text" class="form-control" id="contaDigito" [ngModel]="conta?.getNumeroDigito()"
            (ngModelChange)="conta?.setNumeroDigito($event)" name="conta.numeroDigito" maxlength="2" UiNumeros required>
        </div>
        <div class="form-group">
          <input type="radio" name="tipoconta" [ngModel]="conta?.isPoupanca()"
            (ngModelChange)="conta?.setPoupanca($event)" name="conta.poupanca" [value]="false" required>
          Corrente
          <input type="radio" name="tipoconta" [ngModel]="conta?.isPoupanca()"
            (ngModelChange)="conta?.setPoupanca($event)" name="conta.poupanca" [value]="true" required>
          Poupança
        </div>
        <button (click)="irParaTelaResgatarVouchers()" type="button" class="btn btn-danger-v2">
          Cancelar
        </button>
        <button type="submit" class="btn btn-success-v2">
          Concluir
        </button>
      </form>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/voucher/voucher-dados-transferencia/voucher-dados-transferencia.component.html